import jwtDecode from 'jwt-decode';

export const SESSION_AUTH_TOKEN = 'authCmsToken';

export class SecurityService {
  public getAuthToken() {
    return sessionStorage.getItem(SESSION_AUTH_TOKEN);
  }

  public setAuthToken(token: string) {
    sessionStorage.setItem(SESSION_AUTH_TOKEN, token);
  }

  public removeAuthToken() {
    sessionStorage.removeItem(SESSION_AUTH_TOKEN);
  }

  public isAuth(): boolean {
    const authToken = this.getAuthToken();
    return authToken !== null;
  }

  public getAuthUser() {
    const authToken = sessionStorage.getItem(SESSION_AUTH_TOKEN);
    let authUser: any = null;
    if(authToken) {
      authUser = jwtDecode(authToken);
    }
    return authUser;
  }

  public getAuthorizeHeaders(): any {
    const config = {
      headers: {
        Authorization: 'Bearer '+ sessionStorage.getItem(SESSION_AUTH_TOKEN)
      }
    }
    return config;
  }

  public handleError(error: any, $router: any) {
    const status = error.response.status;
    if(status === 401) {
      securityService.removeAuthToken();
      window.location.href = '/';
    }
  }

}

const securityService = new SecurityService();
export default securityService;
